import { atom } from "recoil"

import type { Client } from "interfaces/ClientIF"

export const clientState = atom<Client | null>({
  key: "clientState",
  default: null,
})
